const env = 'development';

const baseUrl = 'https://api-stage.etch.app/skids'

const apiDefaults = {
  traffic: {
   
  }, 
  RTA: {
    routes: `${baseUrl}/feed/routes`,
    patternDetails: `${baseUrl}/feed/7f12a9b8-0e6c-4f3e-bdf2-9c62a45a9b0c/patterns/`,
    stopDetails: `${baseUrl}/feed/7f12a9b8-0e6c-4f3e-bdf2-9c62a45a9b0c/stops/`,
  }

};

const api: any = {
  development: {
    ...apiDefaults,
  },
  stage: {
    ...apiDefaults,
  },
  prod: {
    ...apiDefaults,
  },
};

export const config = {
  map: {
    apiKey: process.env.REACT_APP_MAPBOX_API_KEY || '',
    center: [-81.675, 41.4834] as [number, number],
    zoom: 12
  },
  here: {
    apiKey: process.env.REACT_APP_HERE_API_KEY || ''
  },
  services: api[env],
  debug: false,
  dataRefreshInterval: 60000,
  autoRotationInterval: 20000,

  // Mock API data instead of real API calls (for testing without API keys)
  useMocks: false,
  simulatedNetworkDelay: 0,

  // Add 2 weeks to API timestamps to access future GTFS feed (Dec 7+)
  twoWeekOffset: false,

  // if both true, 500 will be thrown
  throwMockAPI500: false,
  throwMockAPI404: false,

  loadingScreen: false,
  loadingTime: 1000,

  // Screen toggles
  screens: {
    driveTimesView: true,
    stopView: true,
    trainView: true,
    mapView: false
  }
};